import React from 'react';
import { PageHeader, Typography, Space, List, Image } from 'antd';

const { Text, Link } = Typography;

const Overview = () => {
  return (
    <>
        <PageHeader
            className="site-page-header"
            title="Описание"
        />
        <h2>Schedule - расписание курса RS School</h2>
        <Image
            width={800}
            src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601226927/documentation/Screenshot_2020-09-27_at_20.15.12_svch2j.png"
        />
        <p>В качестве данных для приложения использовалось расписание этого курса:</p>
        <p>
            <a href='https://docs.google.com/spreadsheets/d/18cSE1xbAVuNostllMtyUVNo1q0lR25D3cTCMDb0qUQ8/edit#gid=0'>
                Трехмесячный курс EPAM
            </a>
        </p>
        <p>К расписанию курса добавлено несколько тестовых записей с префиксом Test_, чтобы показать все теги и карту для оффлайновых мероприятий</p>
        <h3>Интерактивные функции расписания отличаются для ментора и студента.</h3>
        <h4>Возможности студента:</h4>
        <ul>
            <li>просмотр расписания в виде таблицы (основная форма расписания), календаря либо списка</li>
            <li>просмотр детальной информации об отдельных заданиях расписания</li>
            <li>выбор темы оформления - светлой либо темной</li>
            <li>возможность сохранения настроек отображения в <code>localStorage</code></li>
        </ul>
        <h4>Дополнительные возможности ментора:</h4>
            <ul>
                <li>редактирование расписания - добавление, удаление и изменение данных</li>
                <li>редактирование страницы задания - добавление, удаление и изменение данных</li>
            </ul>
        <h3>Использованные в проекте технологии:</h3>
        <ul>
            <li>React + Redux, redux-saga, redux-persist</li>
            <li>Ant Design</li>
            <li>Typescript</li>
            <li>Less</li>
            <li>Webpack</li>
            <li>Axios, google-maps, moment, react-color, react-css-theme-switcher</li>
        </ul>
    </>
  );
};

export default Overview;